import { hileiaHttp } from '@/utils/http'

const apis = {
  inviteSearch: '/hiapigw/app/coc/inviteSearch',
  inviteCoc: '/hiapigw/app/coc/invite',
  getInviteList: '/hiapigw/app/coc/inviteList',
  inviteAccept: '/hiapigw/app/coc/inviteAccept',
  inviteReject: '/hiapigw/app/coc/inviteReject',
}

/**
 * 搜索外部联系人用于添加
 */
export function inviteSearch(params) {
  return hileiaHttp.get(apis.inviteSearch, {
    params
  })
}

/**
 * 添加外部联系人
 */
export function inviteCoc(data) {
  return hileiaHttp.post(apis.inviteCoc, data)
}

/**
 * 获取邀请列表（发出、收到）
 */
export function getInviteList() {
  return hileiaHttp.get(apis.getInviteList)
}

/**
 * 拒绝添加好友的申请
 */
export function acceptInvite(data) {
  return hileiaHttp.post(apis.inviteAccept, data)
}

/**
 * 接受添加好友的申请
 */
export function rejectInvite(inviteId) {
  return hileiaHttp.post(apis.inviteReject, {
    inviteId
  })
}
